//**
// This utility use to generate the validation rules from the form fields 
//
//**/

import { FormFieldTypes } from "../../components/finalForms/libs/data/formFieldType";
import { ErrorMessage } from "./../../data/appMessages";


export const getValidationRules = (formFields) => {
    let valRules = {};

    const extractRules = (fields) => {
        fields.forEach(element => {
            if (element.validation && element.validation.length > 0) {
                let fieldValRules = element.validation.map(valItem => getValidationRule(element, valItem));
                valRules[element.dataField] = fieldValRules;
            }
            if (element.row) {
                element.row.forEach(row => extractRules(row.fields));
            }
        });
    };

    extractRules(formFields);
    return valRules;
};

export const getNewFormValidationRules = (sections) => {
    let valRules = {};

    const processField = (field) => {
        if (field.validation && field.validation.length > 0) {
            const fieldValRules = field.validation.map(valItem => getValidationRule(field, valItem));
            valRules = {
                ...valRules,
                [field.dataField]: fieldValRules
            };
        }
    };

    const processRowGroup = (rowGroup) => {
        rowGroup.fields.forEach(processField);
    };

    sections.forEach(section => {
        if (section.rowGroup && section.rowGroup.length > 0) {
            section.rowGroup.forEach(processRowGroup);
        } else if (section.fields && section.fields.length > 0) {
            section.fields.forEach(processField);
        }
    });

    return valRules;
};


// Note: Element is not use as of now
const getValidationRule = (element, validation) => {

    let valObj = {};
    switch (validation.type) {
        case "require":
            valObj = {
                type: validation.type,
                message: element.fieldType === FormFieldTypes.SELECT ? ErrorMessage.SelectRequired.replace('{0}', element.Field_Name) : ErrorMessage.FieldRequired.replace('{0}', element.Field_Name)
            }
            break;
        case "noWhitespace":
            valObj = {
                type: validation.type,
                message: `${element.Field_Name} cannot contain spaces.`
            }
            break;
        case "email":
            valObj = {
                type: validation.type,
                message: ErrorMessage.EmailAddressNotValid
            }
            break;
        case "password":
            valObj = {
                type: validation.type,
                message: ErrorMessage.NOTVALIDPATTERN.replace("{0}", "Password")
            }
            break;
        case 'compare':
            valObj = {
                type: validation.type,
                compareEle: validation.compareEle,
                message: ErrorMessage.CompareField.replace("{0}", element.Field_Name)
            }
            break;
        case 'file':
            valObj = {
                type: validation.type,
                message: ''
            };
            break;
        case 'image':
            valObj = {
                type: validation.type,
                message: ''
            };
            break;
        case 'validEIN':
        case 'validPhone':
        case 'validFax':
            valObj = {
                type: validation.type,
                message: ErrorMessage.InvalidField.replace("{0}", validation.type === 'validEIN' ? "EIN number" : validation.type === 'validPhone' ? "phone number" : "fax number")
            };
            break;
        default:
            break;
    }
    // Please enter all the case
    return valObj;

}
